import { Alert, Button, Text } from '@ui/themed';
import { t } from 'i18next';
import { isShopify, useEnv } from '../../../context/env-context';
import { useHandlers } from '../../../context/page-context';
import { PLATFORM_PATH } from '../../platform/constants';
import { I18N_PAGE } from '../constants';

const ALERT = `${I18N_PAGE}.shopify_alert` as const;

export function ShopifyConfigurationsAlert() {
  const env = useEnv();
  const { navigationHandler } = useHandlers();

  if (!isShopify(env.connected_platform)) {
    return null;
  }

  return (
    <Alert variant="info" headingLevel="h2" title={t(`${ALERT}.title`)}>
      <div className="flex w-full flex-col items-start gap-2">
        <Text>{t(`${ALERT}.description`)}</Text>
        <Button
          variant="secondary"
          icon="settings"
          onClick={() => navigationHandler.navigate(PLATFORM_PATH)}
        >
          {t(`${ALERT}.action`)}
        </Button>
      </div>
    </Alert>
  );
}
